import { equals } from 'ramda';
import { useFiltersProvider } from 'my-phr/context';
import { initialStateFiltersProvider } from 'my-phr/context/FiltersProvider';

export function useTimelineFilterState() {
  const [{ filters }] = useFiltersProvider();
  const filtersInDefaultState = equals(initialStateFiltersProvider, filters);
  return { inDefaultState: filtersInDefaultState };
}
